import codepenDarkIcon from './codepen.dark.raw.svg';
import codepenIcon from './codepen.raw.svg';
import dribbbleIcon from './dribbble.raw.svg';
import framerDarkIcon from './framer.dark.raw.svg';
import framerIcon from './framer.raw.svg';
import githubDarkIcon from './github.dark.raw.svg';
import githubIcon from './github.raw.svg';
import googleDocsIcon from './google-docs.raw.svg';
import googleFormsIcon from './google-forms.raw.svg';
import googleSheetsIcon from './google-sheets.raw.svg';
import googleSlidesIcon from './google-slides.raw.svg';
import loomIcon from './loom.raw.svg';
import soundcloudIcon from './soundcloud.raw.svg';
import trelloIcon from './trello.raw.svg';
import typeformDarkIcon from './typeform.dark.raw.svg';
import typeformIcon from './typeform.raw.svg';
import youtubeIcon from './youtube.raw.svg';

/**
 * List of common used embeds that we want users to discover.
 */
export const EMBEDS: Array<{ key: string; title: string; icon: string; iconDark?: string }> = [
    // Medias
    {
        key: 'youtube',
        title: 'Youtube',
        icon: youtubeIcon,
    },
    {
        key: 'soundcloud',
        title: 'Soundcloud',
        icon: soundcloudIcon,
    },
    {
        key: 'loom',
        title: 'Loom',
        icon: loomIcon,
    },
    // Design / Product
    {
        key: 'github',
        title: 'GitHub Gist',
        icon: githubIcon,
        iconDark: githubDarkIcon,
    },
    {
        key: 'framer',
        title: 'Framer',
        icon: framerIcon,
        iconDark: framerDarkIcon,
    },
    {
        key: 'codepen',
        title: 'Codepen',
        icon: codepenIcon,
        iconDark: codepenDarkIcon,
    },
    {
        key: 'dribbble',
        title: 'Dribbble',
        icon: dribbbleIcon,
    },
    // Admin
    {
        key: 'trello',
        title: 'Trello',
        icon: trelloIcon,
    },
    {
        key: 'typeform',
        title: 'Typeform',
        icon: typeformIcon,
        iconDark: typeformDarkIcon,
    },
    {
        key: 'google-docs',
        title: 'Google Docs',
        icon: googleDocsIcon,
    },
    {
        key: 'google-sheets',
        title: 'Google Sheets',
        icon: googleSheetsIcon,
    },
    {
        key: 'google-slides',
        title: 'Google Slides',
        icon: googleSlidesIcon,
    },
    {
        key: 'google-form',
        title: 'Google Forms',
        icon: googleFormsIcon,
    },
];
